class StoreHeaderEvents extends HTMLElement {
  constructor() {
    super();
    
    this.handleClick = this.handleClick.bind(this);
  }
  
  connectedCallback() {
    const links = this.querySelectorAll('a');
    
    links.forEach(link => {
      link.addEventListener('click', this.handleClick);
    });
  }

  disconnectedCallback() {
    const links = this.querySelectorAll('a');
    
    links.forEach(link => {
      link.removeEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const link = event.currentTarget;
    
    const eventData = {
      linkText: link.innerText.trim(),
      linkClasses: Array.from(link.classList)
    };
    
    Shopify.analytics.publish('header_link_click', eventData);
  }
}

customElements.define('store-header-events', StoreHeaderEvents);
